import ApiEndpoint from './api_endpoint';

export default class ListPerson extends ApiEndpoint {
  execute(callback = undefined, session = undefined, externalIdentifier = '') {
    if (session === undefined) {
      return this.session.get('/person/' + externalIdentifier, undefined, callback);
    }
    return session.get('/person/' + externalIdentifier, undefined, callback);
  };
}
